import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopSpecializationsByDemandJobPostView = async (HubIds: string[], Locations?: string[], fromQuarter?: string, toQuarter?: string) => {
    const { path, method } = endpoints.educationCareerPath.getTopSpecializationsByDemandJobPostView;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, Locations, fromQuarter, toQuarter },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
